import { z } from 'zod';

export const alarmSchema = z.object({
  shop_id: z.string().min(1).max(64),
  machine_id: z.string().min(1).max(64),
  alarm_code: z.string().min(1).max(64),
  program_name: z.string().max(256).optional(),
  first_seen_at: z.string().datetime({ offset: true }),
  last_seen_at: z.string().datetime({ offset: true }),
  cleared_at: z.string().datetime({ offset: true }).nullable(),
});

export type Alarm = z.infer<typeof alarmSchema>;
